import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiGetCountNotApprovedProjects } from '../../services/apiService';

export const fetchApprovalCount = createAsyncThunk(
	'approval/fetchCount',
	async () => {
		const { count_not_approved } = await apiGetCountNotApprovedProjects();
		return count_not_approved;
	}
);

interface ApprovalState {
	count: number;
	status: 'idle' | 'loading' | 'failed';
}

const initialState: ApprovalState = {
	count: 0,
	status: 'idle',
};

const approvalSlice = createSlice({
	name: 'approval',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(fetchApprovalCount.pending, state => {
				state.status = 'loading';
			})
			.addCase(
				fetchApprovalCount.fulfilled,
				(state, action: PayloadAction<number>) => {
					state.status = 'idle';
					state.count = action.payload;
				}
			)
			.addCase(fetchApprovalCount.rejected, state => {
				state.status = 'failed';
			});
	},
});

export default approvalSlice.reducer;
